
import { createAction, handleActions } from 'redux-actions';

const setShowCreateInvoiceModal = createAction("SCREENS/VALUATION_VIEW/SET_SHOW_CREATE_INVOICE_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowCreateInvoiceModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowCreateInvoiceModal, reducer };